import { Auth } from 'firebase/auth';
import { Firestore } from 'firebase/firestore';
import { Functions } from 'firebase/functions';
import { FirebaseStorage } from 'firebase/storage';


import { FirebaseAiClient } from './ai';
import { FirebaseAssetStore } from './assets';
import { FirebaseBillingStore } from './billing';
import { FirebaseCommentStore } from './comments';
import { FirebaseContentStore } from './content';
import { FirebaseEntityStore } from './entities';
import { FirebaseNarrativeStore } from './narrative';
import { FirebaseNovelStore } from './novel';
import { FirebaseUserStore } from './users';

import type { AppBackend } from '../index';

export class FirebaseBackend implements AppBackend {
  novels: FirebaseNovelStore;
  entities: FirebaseEntityStore;
  narrative: FirebaseNarrativeStore;
  content: FirebaseContentStore;
  comments: FirebaseCommentStore;
  assets: FirebaseAssetStore;
  ai: FirebaseAiClient;
  billing: FirebaseBillingStore;
  users: FirebaseUserStore;

  constructor(
    firestore: Firestore,
    storage: FirebaseStorage,
    functions: Functions,
    auth: Auth
  ) {
    this.novels = new FirebaseNovelStore(firestore, functions);
    this.entities = new FirebaseEntityStore(firestore);
    this.narrative = new FirebaseNarrativeStore(firestore, functions);
    this.content = new FirebaseContentStore(firestore, functions);
    this.comments = new FirebaseCommentStore(firestore);
    this.assets = new FirebaseAssetStore(storage, auth, firestore);
    this.ai = new FirebaseAiClient(functions);
    this.billing = new FirebaseBillingStore(firestore, functions);
    this.users = new FirebaseUserStore(firestore, functions);
  }
}
